export default __webpack_public_path__ + "static/logo-3-fadd91b8f57cebae72f0d983c8af5220.png";